<template>
  <div class="search-wrapper">
    <search-comp
      @onSearch="$emit('search', searchParams)"
      @onReset="
        searchParams = { ...defaultSearchParams }
        $emit('search', defaultSearchParams)
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div
                class="das-form-input"
                title="Tìm kiếm theo mã số thuế, tên công ty"
              >
                <div class="label">
                  {{ $t('config.profile.searchBox.info') }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.infoSearching" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      searchShow: true,

      searchParams: {
        infoSearching: null,
        phoneNumber: null
      },
      defaultSearchParams: {
        infoSearching: null,
        phoneNumber: null
      }
    }
  }
}
</script>
